import { createTypes } from 'redux-action-creator';

import { Action } from '../../../types';
import { WaiverWorkItemsListType } from '../../../../types/waiverWorkItem';

export const types: { [key: string]: string } = createTypes(
  ['LOAD_SUCCESS'],
  'WORK_ITEM_LIST_TYPE',
);

export function changeListType(
  listType: WaiverWorkItemsListType,
): Action<WaiverWorkItemsListType> {
  return {
    type: types.LOAD_SUCCESS,
    response: listType,
  };
}
